angular.module( 'acme.view.application.users.assign', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.users.assign.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var usersAssign = {
        name: 'application.users.assign',
        url: '/assign',
        views: {
          "subview-main": {
            controller: 'UsersAssignController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/users/assign/assign.tpl.html'
          }
        },
        data: {
          pageTitle: '  ',
          rule: function(permits) {
            // Allow if state is not in exclusions array
            return (permits.indexOf('application.users.assign') !== -1);
          }
        }
      };

    $stateProvider
      .state(usersAssign);
});
